const TOP_GAP_PX = 8;

function getScrollTopToAlignAtTop(
    container: HTMLElement,
    node: HTMLElement,
    topGap = TOP_GAP_PX
): number {
    const nodeRect = node.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    return container.scrollTop + (nodeRect.top - containerRect.top) - topGap;
}

export function scrollUserMessageNearTop(
    container: HTMLElement,
    userMessageId: string,
    behavior: ScrollBehavior = "auto"
): boolean {
    const node = container.querySelector(
        `[data-chat-message-id="${userMessageId}"]`
    ) as HTMLElement | null;
    if (!node) return false;

    const targetTop = getScrollTopToAlignAtTop(container, node);
    container.scrollTo({
        top: Math.max(0, targetTop),
        behavior,
    });
    return true;
}

export function computeStreamingBottomSpacer(container: HTMLElement, extra = 0): number {
    return Math.max(Math.round(container.clientHeight * 0.92), 320) + extra;
}

export function computeAssistantStreamingMinHeight(container: HTMLElement, extra = 0): number {
    return Math.max(Math.round(container.clientHeight * 0.72), 280) + extra;
}

export function computeTurnLayout(
    container: HTMLElement,
    userMessageId: string
): { assistantMinHeight: number; bottomSpacerHeight: number } | null {
    const userNode = container.querySelector(
        `[data-chat-message-id="${userMessageId}"]`
    ) as HTMLElement | null;
    if (!userNode) return null;

    const targetScrollTop = getScrollTopToAlignAtTop(container, userNode);
    const requiredScrollHeight = targetScrollTop + container.clientHeight;
    const extraScrollRoom = Math.max(0, requiredScrollHeight - container.scrollHeight + 32);

    return {
        assistantMinHeight: computeAssistantStreamingMinHeight(container),
        bottomSpacerHeight: computeStreamingBottomSpacer(container, extraScrollRoom),
    };
}

export function scheduleScrollUserMessageToTop(
    container: HTMLElement,
    userMessageId: string
): void {
    const run = () => scrollUserMessageNearTop(container, userMessageId, "auto");

    run();
    requestAnimationFrame(() => {
        run();
        requestAnimationFrame(() => {
            run();
            window.setTimeout(run, 50);
            window.setTimeout(run, 150);
        });
    });
}
